/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* imeiValidationWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_EDGE_IMEI_TRANSACTION);
  yield takeLatest(ActionConstants.GET_EDGE_IMEI_TRANSACTION_DETAILS, workerSaga);
  yield takeLatest(ActionConstants.GET_EDGE_IMEI_VALIDATION_DETAILS, workerSaga);
  yield takeLatest(ActionConstants.POST_IMEI_BLOCK, workerSaga);
}
